import arham from "../assets/bg-img-1.JPG";
import soletaire from "../assets/bg-img-2.JPG";
import shreeview from "../assets/bg-img-3.JPG";

const projects = [
  {
    number: "1",
    name: "Nakoda mehta sunshine height",
    locationLabel: "Charni Road (W)",
    image: soletaire,
    details: {
      Developer: "Mehta builder and developers",
      Location: "VP Road, Charni Road",
      "Built-Up Area": " 4,00,000 Sq. Ft.",
      Scope: "9-storey residential building",
    },
  },

  {
    number: "2",
    name: "Avisha",
    locationLabel: "Charni Road (W)",
    image: shreeview,
    details: {
      Developer: "Nandivardhan",
      Location: "Charni Road",
      "Built-Up Area": "85,000 Sq. Ft.",
      Scope: "Residential + Commercial tower",
    },
    summary:
      "Redevelopment residential project with premium finishing and Vastu-compliant layouts.",
  },
  {
    number: "3",
    name: "Soletaire 36",
    locationLabel: "Grant Road (W)",
    image: arham,
    details: {
      Developer: "Safeway Projects Pvt. Ltd",
      Location: "Tardeo",
      "Built-Up Area": "1,50,000 Sq. Ft.",
      Scope: "Residential + Commercial tower",
    },
  },
];

const FlagshipProjects = () => {
  return (
    <section className="max-w-6xl mx-auto px-4 py-16 bg-white text-black font-sans">
      <h1 data-aos="fade-up" className="flagship">
        Flagship Projects
      </h1>

      {projects.map((project, index) => {
        const isEven = index % 2 === 1;
        return (
          <div
            key={project.number}
            className={`grid grid-cols-1 project-cards md:grid-cols-2 gap-6 mb-10 bg-gray-50 rounded-lg shadow ${
              isEven ? "md:flex-row-reverse" : ""
            }`}
            data-aos="fade-up"
            data-aos-delay={`${200 + index * 100}`}
          >
            <div
              className="rounded card-img w-full h-64 md:h-auto bg-center bg-cover"
              style={{ backgroundImage: `url(${project.image})` }}
            ></div>

            <div className="card-content">
              <h2>
                <span className="text-blue-800">
                  {project.number}. {project.name}
                </span>{" "}
                {project.locationLabel}
              </h2>

              {project.details ? (
                <ul className="space-y-2 mt-4">
                  {Object.entries(project.details).map(([label, value]) => (
                    <li className="flex justify-between" key={label}>
                      {label}: <span className="ml-10">{value}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="mt-4">{project.summary}</p>
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default FlagshipProjects;
